<template>
  <div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="35%">
      <el-form :model="form" label-position="right" :rules="rules" ref="modifyForm">
        <el-form-item
          label="机场名称"
          :label-width="labelWidth"
          prop="airportName"
          v-if="showAirportForm"
        >
          <el-input v-model="form.airportName" autocomplete="off"></el-input>
        </el-form-item>

        <div v-else>
          <el-form-item label="车站名称" :label-width="labelWidth" prop="trainStationName">
            <el-input v-model="form.trainStationName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="英文名称" :label-width="labelWidth">
            <el-input v-model="form.englishName" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="首字缩写" :label-width="labelWidth">
            <el-input v-model="form.acronym" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="车站编码" :label-width="labelWidth">
            <el-input v-model="form.code" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="车站代号" :label-width="labelWidth">
            <el-input v-model="form.mark" autocomplete="off"></el-input>
          </el-form-item>
        </div>

        <el-form-item label="当前城市" :label-width="labelWidth" prop="cityId">
          <div class="current-city">
            <div class="city-name">
              <flow-status />
              <span>{{form.cityName}}</span>
            </div>
            <el-checkbox v-model="canSelect" @change="canSelectChanged">切换城市</el-checkbox>
          </div>
        </el-form-item>

        <el-form-item
          label="所在城市"
          :label-width="labelWidth"
          prop="cityId"
          v-show="canSelect"
          class="select-city"
        >
          <el-select v-model="currentProvinceId">
            <el-option
              v-for="item in provinces"
              :key="item.provinceId"
              :label="item.provinceName"
              :value="item.provinceId"
            ></el-option>
          </el-select>

          <el-select v-model="currentCityId" placeholder="请选择" @change="setFormCity">
            <el-option v-for="item in cities" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelModify">取 消</el-button>
        <el-button type="primary" @click="confirmModify">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FlowStatus from "@/components/FlowStatus/FlowStatus";

export default {
  components: {
    FlowStatus
  },

  props: {
    requestApi: {
      type: Object,
      required: true
    },

    formData: {
      type: Object,
      required: true
    },

    stationType: {
      type: String,
      required: true
    },

    provinces: {
      type: Array,
      required: true
    },

    initCity: {
      type: Object,
      default: _ => {
        return {};
      }
    }
  },

  computed: {
    showAirportForm() {
      return this.stationType === "airport";
    },

    selectedCityName() {
      const city = this.cities.find(item => item.id === this.form.cityId);

      return city ? city.name : "";
    },

    currentRequestApi() {
      return this.form.id
        ? this.requestApi.modifyStation
        : this.requestApi.addStation;
    },

    requestData() {
      let requestData = this.showAirportForm
        ? this.getAirportRequestData()
        : this.getTrainStationRequestData();

      requestData.distributed = true;
      return requestData;
    }
  },

  watch: {
    formData(newValue) {
      this.form = this.$js.deepClone(newValue);
    },

    currentProvinceId(newValue) {
      this.currentCityId = "";
      if (newValue) this.setCities(newValue);
    }
  },
  data() {
    return {
      dialogVisible: false,
      labelWidth: "80px",
      canSelect: false,

      currentProvinceId: "",
      currentCityId: "",
      cities: [],

      form: {
        airportName: "",
        trainStationName: "",
        englishName: "",
        acronym: "",
        code: "",
        mark: "",
        cityId: "",
        distributed: true
      },

      rules: {
        airportName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        trainStationName: [
          { required: true, message: "请选择活动区域", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    handleClose(done) {
      this.$refs.modifyForm.clearValidate();
      done();
    },

    canSelectChanged() {
      this.resetSelectCity();
    },

    setCities(provinceId) {
      this.$api.getCitiesByProvinceId(provinceId).then(res => {
        this.cities = res;
      });
    },

    setFormCity(cityId) {
      const city = this.cities.find(item => item.id === cityId);
      this.form.cityId = cityId;
      this.form.cityName = city.name;
    },

    confirmModify() {
      this.currentRequestApi(this.requestData).then(_ => {
        this.$message.success("提交成功！");
        this.dialogVisible = false;

        this.$parent.setStationList();
      });
    },

    resetSelectCity() {
      this.currentProvinceId = "";
      this.currentCityId = "";
    },

    cancelModify() {
      this.$refs.modifyForm.clearValidate();

      this.dialogVisible = false;
      this.canSelect = false;
    },

    getAirportRequestData() {
      let { airportName, cityId, cityName } = this.form;
      let requestData = { airportName, cityId, cityName };

      this.form.id ? (requestData.id = this.form.id) : "";

      return requestData;
    },

    getTrainStationRequestData() {
      let {
        trainStationName,
        acronym,
        code,
        mark,
        englishName,
        cityId,
        cityName
      } = this.form;
      let requestData = {
        trainStationName,
        acronym,
        code,
        mark,
        englishName,
        cityId,
        cityName
      };

      this.form.id ? (requestData.id = this.form.id) : "";

      return requestData;
    }
  }
};
</script>

<style scoped lang="scss">
.current-city {
  display: flex;

  .city-name {
    width: 200px;

    .flow-status {
      margin: 0 5px 0 15px;
    }
  }
}

.select-city {
  ::v-deep .el-form-item__content {
    display: flex;

    .el-select {
      flex: 1;
    }

    .el-select:nth-child(1) {
      padding-right: 25px;
    }
  }
}
</style>